import styled from 'styled-components';

import {Device} from '../../../constants';

const StyledBattlePassFooterContainer = styled.section`
  position: relative;

  @media screen and ${Device.mobileL} {
    height: unset;
    max-height: 100vh;

    p {
      width: 100%;
    }
  }
`;

export default StyledBattlePassFooterContainer;
